export default "__VITE_ASSET__CFbDXcRG__"